var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPandas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 748.525,
    height: 307.066,
    viewBox: "0 0 748.525 307.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pandas",
    "data-name": "pandas",
    transform: "translate(34.572 -83.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7011",
    "data-name": "Path 7011",
    d: "M-8469.152-7812.272s-.843-12.628,9.892-13.049,285.609-.21,285.609-.21,11.177.632,10.734,12.208-.21,169.219-.21,169.219,2.315,11.786-18.1,11.576-272.35-.21-272.35-.21-16,1.053-16-10.944S-8469.152-7812.272-8469.152-7812.272Z",
    transform: "translate(8473.427 7909.235)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M181.9,617.661l-2.227,11.173c-.168.854-.343,1.724-.534,2.585a10.9,10.9,0,0,0-5.6.313,52.246,52.246,0,0,1,3.844,6.429c-1.4,4.324-3.462,8.321-6.91,11.211a17.327,17.327,0,0,1-16.74,2.944l.1-.442c-3.707-7.192-1.693-16.26,2.913-22.9a44.526,44.526,0,0,1,8.275-8.748c3.112-2.593,6.475-4.919,9.808-7.215a4.568,4.568,0,0,1,7.07,4.652Z",
    transform: "translate(-136.673 -295.814)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a4b268fa-75d0-4ac1-9d87-14bdca948464-2189",
    d: "M154.885,686.245c-.937-6.828-1.9-13.743-1.244-20.644a32.468,32.468,0,0,1,6.261-17.023,28.317,28.317,0,0,1,7.266-6.584c.727-.458,1.395.693.672,1.149a26.922,26.922,0,0,0-10.649,12.849c-2.318,5.9-2.691,12.325-2.288,18.589.242,3.788.754,7.55,1.27,11.31a.686.686,0,0,1-.465.819.67.67,0,0,1-.819-.465Z",
    transform: "translate(-137.034 -302.859)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M165.543,250.119q49.005-.852,98.021-.245t97.985,2.688q27.482,1.166,54.942,2.793c1.471.087,1.466-2.2,0-2.288q-48.927-2.9-97.925-4.333t-98.011-1.4q-27.507.018-55.011.5a1.145,1.145,0,0,0,0,2.288Z",
    transform: "translate(-139.648 -125.979)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M464.08,231.131l14.286-1.063c1.459-.109,1.471-2.4,0-2.288l-14.286,1.063C462.621,228.952,462.609,231.24,464.08,231.131Z",
    transform: "translate(-210.504 -121.337)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M464.08,249.131l14.286-1.063c1.459-.109,1.471-2.4,0-2.288l-14.286,1.063C462.621,246.952,462.609,249.24,464.08,249.131Z",
    transform: "translate(-210.504 -125.609)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M462.672,241.241l20.311,1.845c1.466.133,1.457-2.156,0-2.288l-20.311-1.845C461.206,238.82,461.215,241.109,462.672,241.241Z",
    transform: "translate(-210.172 -123.989)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M175.37,228.141a5.061,5.061,0,0,0-4.677,3.055,4.556,4.556,0,0,0,1.048,5.412,5.416,5.416,0,0,0,5.132,1.043,4.578,4.578,0,0,0,3.068-4.3,5.115,5.115,0,0,0-3.187-4.934,1.149,1.149,0,0,0-1.407.8,1.176,1.176,0,0,0,.8,1.407c.2.077-.182-.1,0,0,.077.042.155.079.23.124s.125.079.187.12c.214.139-.1-.1.032.023.118.109.236.215.343.335.041.045.2.171.076.083-.095-.067-.037-.052,0,0s.057.081.084.122a4.086,4.086,0,0,1,.243.42c.017.033.032.068.049.1.032.062.078.079,0,0s-.026-.07,0,0c.017.047.035.094.052.141a4.405,4.405,0,0,1,.135.471c.017.074.03.148.045.222.051.263-.007-.163,0,.032.01.163.022.324.019.488q0,.112-.01.224c0,.037-.007.074-.009.112-.012.18-.012-.066.013-.082a2.112,2.112,0,0,0-.1.471c-.021.071-.045.141-.068.211-.08.245.075-.134-.01.034a4.182,4.182,0,0,1-.234.419c-.037.057-.178.184-.063.1s-.065.07-.106.112-.106.108-.162.159a1.3,1.3,0,0,1-.113.1c-.007,0,.191-.132.084-.064-.136.087-.265.179-.408.255-.017.009-.2.094-.2.1-.008-.031.235-.086.068-.032-.035.011-.07.025-.1.037a3.731,3.731,0,0,1-.465.124c-.036.007-.074.011-.11.02-.118.031.113-.018.12-.014a1,1,0,0,0-.26.023,4.25,4.25,0,0,1-.487,0l-.113-.008c-.087-.005-.151-.068-.035,0,.09.053.082.014,0,0l-.111-.02a4.427,4.427,0,0,1-.476-.117c-.084-.026-.167-.055-.25-.084a.663.663,0,0,1-.105-.041c0-.009.214.1.1.041-.143-.077-.291-.142-.43-.226-.074-.045-.146-.094-.218-.142a.7.7,0,0,1-.091-.065c0-.01.177.152.086.065-.116-.111-.24-.21-.35-.328l-.074-.082-.024-.028q-.093-.114,0,0c.061.018.058.084,0,0l-.063-.092a2.391,2.391,0,0,1-.236-.422c.006,0,.1.275.028.064-.014-.04-.029-.079-.042-.119q-.039-.119-.069-.24c-.02-.08-.03-.163-.05-.243-.034-.135.02.106.014.1s-.011-.136-.012-.164c-.009-.18.011-.354.014-.532,0-.138-.011.108-.014.1a.388.388,0,0,1,.022-.122c.021-.094.04-.188.065-.281s.062-.212.1-.316c.014-.039.031-.077.044-.116.048-.144-.1.173-.016.044.109-.178.19-.371.305-.547.027-.042.194-.274.105-.157s.09-.1.124-.142c.14-.156.305-.285.451-.434.086-.089-.06.044-.069.05.045-.032.089-.066.135-.1q.119-.082.244-.155c.094-.055.2-.1.291-.154.107-.069-.082.03-.086.032a.851.851,0,0,1,.153-.058c.089-.031.474-.2.555-.146,0,0-.293.023-.059.008.055,0,.11-.009.165-.011.112,0,.223,0,.335,0a1.152,1.152,0,0,0,1.144-1.144,1.169,1.169,0,0,0-1.144-1.144Z",
    transform: "translate(-141.021 -121.424)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M196.37,228.141a5.061,5.061,0,0,0-4.678,3.055,4.556,4.556,0,0,0,1.048,5.412,5.417,5.417,0,0,0,5.132,1.043,4.578,4.578,0,0,0,3.068-4.3,5.115,5.115,0,0,0-3.187-4.934,1.149,1.149,0,0,0-1.407.8,1.176,1.176,0,0,0,.8,1.407c.2.077-.182-.1,0,0,.077.042.155.079.23.124s.125.079.187.12c.214.139-.1-.1.032.023.118.109.236.215.343.335.041.045.2.171.076.083-.095-.067-.037-.052,0,0s.057.081.084.122a4.084,4.084,0,0,1,.243.42c.017.033.032.068.049.1.032.062.078.079,0,0s-.026-.07,0,0c.017.047.035.094.052.141a4.413,4.413,0,0,1,.135.471c.017.074.03.148.045.222.051.263-.007-.163,0,.032.01.163.022.324.019.488q0,.112-.01.224c0,.037-.007.074-.009.112-.012.18-.012-.066.013-.082a2.112,2.112,0,0,0-.1.471c-.02.071-.045.141-.068.211-.08.245.075-.134-.01.034a4.179,4.179,0,0,1-.234.419c-.037.057-.178.184-.063.1s-.065.07-.106.112-.106.108-.162.159a1.3,1.3,0,0,1-.113.1c-.007,0,.191-.132.084-.064-.136.087-.265.179-.408.255-.017.009-.2.094-.2.1-.008-.031.235-.086.068-.032-.035.011-.069.025-.1.037a3.73,3.73,0,0,1-.465.124c-.036.007-.074.011-.11.02-.118.031.113-.018.12-.014a1,1,0,0,0-.26.023,4.249,4.249,0,0,1-.487,0l-.113-.008c-.087-.005-.151-.068-.035,0,.09.053.082.014,0,0l-.111-.02a4.425,4.425,0,0,1-.476-.117c-.084-.026-.167-.055-.25-.084a.663.663,0,0,1-.105-.041c0-.009.214.1.1.041-.143-.077-.291-.142-.43-.226-.074-.045-.146-.094-.218-.142a.7.7,0,0,1-.091-.065c0-.01.177.152.086.065-.116-.111-.24-.21-.35-.328l-.074-.082-.024-.028q-.093-.114,0,0c.061.018.058.084,0,0l-.063-.092a2.391,2.391,0,0,1-.236-.422c.006,0,.1.275.028.064-.014-.04-.029-.079-.042-.119q-.039-.119-.069-.24c-.02-.08-.03-.163-.05-.243-.034-.135.02.106.014.1s-.011-.136-.012-.164c-.009-.18.011-.354.014-.532,0-.138-.011.108-.014.1a.387.387,0,0,1,.022-.122c.021-.094.04-.188.065-.281s.062-.212.1-.316c.014-.039.031-.077.044-.116.048-.144-.1.173-.016.044.109-.178.19-.371.305-.547.027-.042.194-.274.105-.157s.09-.1.124-.142c.14-.156.305-.285.451-.434.086-.089-.06.044-.069.05.045-.032.089-.066.135-.1q.119-.082.244-.155c.094-.055.2-.1.291-.154.107-.069-.082.03-.086.032a.851.851,0,0,1,.153-.058c.089-.031.474-.2.555-.146,0,0-.293.023-.059.008.055,0,.11-.009.165-.011.112,0,.223,0,.335,0a1.152,1.152,0,0,0,1.144-1.144,1.169,1.169,0,0,0-1.144-1.144Z",
    transform: "translate(-146.004 -121.424)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M217.37,228.141a5.061,5.061,0,0,0-4.677,3.055,4.556,4.556,0,0,0,1.048,5.412,5.417,5.417,0,0,0,5.132,1.043,4.578,4.578,0,0,0,3.068-4.3,5.115,5.115,0,0,0-3.187-4.934,1.149,1.149,0,0,0-1.407.8,1.176,1.176,0,0,0,.8,1.407c.2.077-.182-.1,0,0,.077.042.155.079.23.124s.125.079.187.12c.214.139-.1-.1.032.023.118.109.236.215.343.335.041.045.2.171.076.083-.095-.067-.037-.052,0,0s.057.081.084.122a4.078,4.078,0,0,1,.243.42c.017.033.032.068.049.1.032.062.078.079,0,0s-.026-.07,0,0c.017.047.035.094.052.141a4.4,4.4,0,0,1,.135.471c.017.074.03.148.045.222.051.263-.007-.163,0,.032.01.163.022.324.019.488q0,.112-.01.224c0,.037-.007.074-.009.112-.012.18-.012-.066.013-.082a2.112,2.112,0,0,0-.1.471c-.02.071-.045.141-.068.211-.08.245.075-.134-.01.034a4.182,4.182,0,0,1-.234.419c-.037.057-.178.184-.063.1s-.065.07-.106.112-.106.108-.162.159a1.3,1.3,0,0,1-.113.1c-.007,0,.191-.132.084-.064-.136.087-.265.179-.408.255-.017.009-.2.094-.2.1-.008-.031.235-.086.068-.032-.035.011-.069.025-.1.037a3.731,3.731,0,0,1-.465.124c-.036.007-.074.011-.11.02-.118.031.113-.018.12-.014a1,1,0,0,0-.26.023,4.25,4.25,0,0,1-.487,0l-.113-.008c-.087-.005-.151-.068-.035,0,.089.053.082.014,0,0l-.111-.02a4.426,4.426,0,0,1-.476-.117c-.084-.026-.167-.055-.25-.084a.663.663,0,0,1-.105-.041c0-.009.214.1.1.041-.143-.077-.291-.142-.43-.226-.074-.045-.146-.094-.218-.142a.7.7,0,0,1-.091-.065c0-.01.177.152.086.065-.116-.111-.24-.21-.35-.328l-.074-.082-.024-.028q-.093-.114,0,0c.061.018.058.084,0,0l-.063-.092a2.388,2.388,0,0,1-.236-.422c.006,0,.1.275.028.064-.014-.04-.029-.079-.042-.119q-.039-.119-.069-.24c-.02-.08-.03-.163-.05-.243-.034-.135.02.106.014.1s-.011-.136-.012-.164c-.009-.18.011-.354.014-.532,0-.138-.011.108-.014.1a.388.388,0,0,1,.022-.121c.021-.094.04-.188.065-.281s.062-.212.1-.316c.014-.039.031-.077.044-.116.048-.144-.1.173-.016.044.109-.178.19-.371.305-.547.027-.042.194-.274.106-.157s.09-.1.124-.142c.14-.156.305-.285.451-.434.086-.089-.06.044-.069.05.045-.032.089-.066.135-.1q.119-.082.244-.155c.094-.055.2-.1.291-.154.107-.069-.082.03-.086.032a.85.85,0,0,1,.153-.058c.089-.031.474-.2.555-.146,0,0-.293.023-.059.008.055,0,.11-.009.165-.011.112,0,.223,0,.335,0a1.152,1.152,0,0,0,1.144-1.144,1.169,1.169,0,0,0-1.144-1.144Z",
    transform: "translate(-150.988 -121.424)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M430.861,390.961H150.275c-7.387-.006-13.374-4.192-13.383-9.359V206.711c.008-5.166,6-9.353,13.383-9.359H430.861c7.388.006,13.374,4.193,13.383,9.359V381.6C444.236,386.769,438.249,390.955,430.861,390.961ZM150.276,198.419c-6.546.005-11.85,3.715-11.857,8.292V381.6c.008,4.577,5.312,8.287,11.857,8.292H430.861c6.545-.005,11.85-3.715,11.857-8.292V206.711c-.007-4.578-5.312-8.287-11.857-8.292Z",
    transform: "translate(-133.109 -114.116)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M153.487,419.507l98.672-.3,98.169-.3,55.377-.168a1.145,1.145,0,0,0,0-2.288l-98.672.3-98.169.3-55.377.168a1.145,1.145,0,0,0,0,2.288Z",
    transform: "translate(-127.159 -177.969)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M218.388,406.471l.61-36.026a1.145,1.145,0,0,0-2.288,0l-.61,36.026A1.145,1.145,0,0,0,218.388,406.471Z",
    transform: "translate(-142.282 -166.788)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M280.224,400.075l1.487-45.282.425-12.938c.048-1.473-2.24-1.471-2.288,0l-1.487,45.282-.425,12.938C277.887,401.548,280.175,401.546,280.224,400.075Z",
    transform: "translate(-156.958 -160.002)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M341.529,313.71c-.9,16.039-2.556,63.346-3.453,79.385-.082,1.471,2.206,1.466,2.288,0,.9-16.039,2.556-63.346,3.453-79.385C343.9,312.239,341.611,312.244,341.529,313.71Z",
    transform: "translate(-171.232 -153.323)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M403.889,393.756l-.28,15.416a1.145,1.145,0,0,0,2.288,0c.331-18.207,1.181-17.614,1.274-22.752a1.145,1.145,0,0,0-2.288,0S404.22,375.549,403.889,393.756Z",
    transform: "translate(-186.786 -170.077)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M464.088,343.6l.259,43.249.074,12.384a1.145,1.145,0,0,0,2.288,0l-.259-43.249-.074-12.384a1.145,1.145,0,0,0-2.288,0Z",
    transform: "translate(-201.14 -160.415)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M153.214,394.837c-1.894-5.2,2.375-10.21,6.762-12.459,5.255-2.695,11.3-3.305,16.612-5.9,7.918-3.873,13.685-10.823,18.817-17.781,5.282-7.161,10.115-14.846,16.827-20.8a33.7,33.7,0,0,1,12.255-7.092,42.235,42.235,0,0,1,17.7-1.188c12.217,1.487,23.542,6.533,35.329,9.74,11.114,3.024,23.358,4.724,34.267.022,5.542-2.389,10.074-6.4,14.942-9.862a49.8,49.8,0,0,1,15.565-7.508,46.286,46.286,0,0,1,33.1,2.916,44.42,44.42,0,0,1,20.95,22.111c4.833,11.545,4.2,24.448,2.625,36.6-.408,3.141-.894,6.272-1.385,9.4-.226,1.44,1.978,2.061,2.206.608,1.966-12.531,3.926-25.459,1.48-38.069a46.107,46.107,0,0,0-17.031-27.743,47.318,47.318,0,0,0-31.2-9.847A51.159,51.159,0,0,0,335.9,321.8c-5.658,2.341-10.45,5.81-15.317,9.46-5,3.753-10.162,6.857-16.375,8.081a48.787,48.787,0,0,1-18.295-.379c-12.38-2.313-23.919-7.615-36.194-10.332-11.372-2.517-23.644-2.769-33.828,3.656-7.834,4.942-13.369,12.614-18.681,20.023-5.266,7.344-10.6,15.2-18.3,20.213-4.7,3.06-9.977,4.189-15.231,5.91s-10.325,4.636-12.473,10.033a9.757,9.757,0,0,0-.2,6.982c.5,1.373,2.711.78,2.206-.608Z",
    transform: "translate(-126.702 -154.587)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M86.17,166.905l0,0,.006,0Z",
    transform: "translate(-20.45 -39.614)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M220.652,360.779a4.547,4.547,0,0,0-5.509-2.039,4,4,0,0,0-2.28,2.123c-.044.1-.069.213-.105.319-.05.08-.109.153-.154.236a4.544,4.544,0,0,0,7.086,5.429A4.893,4.893,0,0,0,220.652,360.779Zm-2.866,1.943C217.8,362.779,217.793,362.832,217.787,362.722Zm-.291-.662Zm-1.284.516C216.195,362.549,216.193,362.545,216.212,362.576Zm.3.258C216.589,362.858,216.56,362.853,216.516,362.833Zm.136.065.03-.014a.038.038,0,0,1-.021,0h0l.024,0,0,0-.014,0c.012,0,.013,0,.014,0,.136-.062.044-.032-.035-.008h-.005a.519.519,0,0,0-.157-.05l-.015-.008c-.044-.031-.265-.2-.06-.023-.045-.039-.089-.078-.131-.121a.593.593,0,0,1-.067-.083q-.04-.069-.078-.14l0-.025c0-.021-.006-.03-.009-.042s0-.027.005-.041a.494.494,0,0,0,.029-.128l.009-.011c.033-.046.062-.1.093-.147-.166.252.065-.028.082-.063,0-.006,0,0,0-.007s0,0,.013-.006c.051-.03.1-.064.152-.093s.307-.1.053-.031c.058-.016.113-.037.171-.053.011,0,.1-.015.142-.023l.084,0,.057,0c-.042.006.145.046.2.055l.023.018c.047.034.1.065.153.1-.221-.143,0,.011.045.054.025.025.049.052.072.079a.621.621,0,0,1,.059.081c.036.066.075.134.113.2l.011.017a.06.06,0,0,0,0,.006,1.8,1.8,0,0,0,.088.311.251.251,0,0,1,0,.026c0,.058.008.116.009.174v.012a1.253,1.253,0,0,0-1.143-.008Z",
    transform: "translate(-141.338 -164.207)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M218.115,364.255s0,0,0,0Z",
    transform: "translate(-152.387 -236.965)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M218.113,364.255h0Z",
    transform: "translate(-152.387 -236.965)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M218.113,364.257h0Z",
    transform: "translate(-152.386 -236.966)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M86.177,166.9Z",
    transform: "translate(-20.452 -39.613)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M150.17,138.9l0,0,.006,0Z",
    transform: "translate(-35.64 -32.968)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M284.652,332.779a4.547,4.547,0,0,0-5.509-2.039,4,4,0,0,0-2.28,2.123c-.044.1-.069.213-.105.319-.05.08-.109.153-.154.236a4.544,4.544,0,0,0,7.086,5.429A4.893,4.893,0,0,0,284.652,332.779Zm-2.866,1.943C281.8,334.779,281.793,334.832,281.787,334.722Zm-.291-.662Zm-1.284.516C280.195,334.549,280.193,334.545,280.212,334.576Zm.3.258C280.589,334.858,280.56,334.853,280.516,334.833Zm.136.065.03-.014a.038.038,0,0,1-.021,0h0l.024,0,0,0-.014,0c.012,0,.013,0,.014,0,.136-.062.044-.032-.035-.008h-.005a.52.52,0,0,0-.157-.05l-.015-.008c-.044-.031-.265-.2-.06-.023-.045-.039-.089-.078-.131-.121a.6.6,0,0,1-.067-.082q-.04-.069-.078-.14l0-.025c0-.021-.006-.03-.009-.043s0-.027.005-.041a.493.493,0,0,0,.029-.128l.009-.011c.033-.046.062-.1.093-.147-.166.252.065-.028.082-.063,0-.006,0,0,0-.007s0,0,.013-.006c.051-.03.1-.064.152-.093s.307-.1.053-.031c.058-.016.113-.037.171-.052.011,0,.1-.015.142-.023l.084,0,.057,0c-.042.006.145.046.2.055l.023.018c.047.034.1.065.153.1-.221-.143,0,.011.045.054.025.025.049.052.072.079a.614.614,0,0,1,.059.081c.036.066.075.134.113.2l.011.017a.051.051,0,0,0,0,.006,1.809,1.809,0,0,0,.088.311c0,.009,0,.017,0,.026,0,.058.008.116.009.174v.012a1.253,1.253,0,0,0-1.143-.008Z",
    transform: "translate(-156.528 -157.561)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M282.113,336.257h0Z",
    transform: "translate(-167.576 -230.32)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M150.177,138.9Z",
    transform: "translate(-35.642 -32.967)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M282.115,336.255s0,0,0,0Z",
    transform: "translate(-167.577 -230.32)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M282.113,336.255h0Z",
    transform: "translate(-167.577 -230.32)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M212.177,152.9Z",
    transform: "translate(-50.357 -36.29)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M346.652,304.779a4.547,4.547,0,0,0-5.509-2.039,4,4,0,0,0-2.28,2.123c-.044.1-.069.213-.105.319-.05.08-.109.153-.154.236a4.544,4.544,0,0,0,7.086,5.429A4.893,4.893,0,0,0,346.652,304.779Zm-2.866,1.943C343.8,306.779,343.793,306.832,343.787,306.722Zm-.291-.662Zm-1.284.516C342.195,306.549,342.193,306.545,342.212,306.576Zm.3.258C342.589,306.858,342.56,306.853,342.516,306.833Zm.136.065.03-.014a.038.038,0,0,1-.021,0h0l.024,0,0,0-.014,0c.012,0,.013,0,.014,0,.136-.062.044-.032-.035-.008h-.005a.519.519,0,0,0-.157-.05l-.015-.008c-.044-.031-.265-.2-.06-.023-.045-.039-.089-.078-.131-.121a.6.6,0,0,1-.067-.082q-.04-.069-.078-.14l0-.025c0-.021-.006-.03-.009-.043s0-.027.005-.041a.5.5,0,0,0,.029-.128l.009-.011c.033-.046.062-.1.093-.147-.166.252.065-.028.082-.063,0-.006,0,0,0-.007s0,0,.013-.006c.051-.03.1-.064.152-.093s.307-.1.053-.031c.058-.016.113-.037.171-.052.011,0,.1-.015.142-.023l.084,0,.057,0c-.042.006.145.046.2.055l.023.018c.047.034.1.065.153.1-.221-.143,0,.011.045.054.025.025.049.052.072.079a.62.62,0,0,1,.059.081c.036.066.075.134.113.2l.011.017a.058.058,0,0,0,0,.007,1.8,1.8,0,0,0,.088.311.249.249,0,0,1,0,.026c0,.058.008.116.009.174v.012a1.253,1.253,0,0,0-1.143-.008Z",
    transform: "translate(-171.243 -150.916)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M212.17,152.905l0,0,.006,0Z",
    transform: "translate(-50.355 -36.291)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M344.113,350.255h0Z",
    transform: "translate(-182.292 -233.642)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M344.113,350.257h0Z",
    transform: "translate(-182.291 -233.643)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M344.115,350.255s0,0,0,0Z",
    transform: "translate(-182.292 -233.642)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M409.652,381.779a4.547,4.547,0,0,0-5.509-2.039,4,4,0,0,0-2.28,2.123c-.044.1-.069.213-.105.319-.05.08-.109.153-.154.236a4.544,4.544,0,0,0,7.086,5.429,4.893,4.893,0,0,0,.961-6.068Zm-2.866,1.943C406.8,383.779,406.793,383.832,406.787,383.722Zm-.291-.662Zm-1.284.516C405.195,383.549,405.193,383.545,405.212,383.576Zm.3.258C405.589,383.858,405.56,383.853,405.516,383.834Zm.136.065.03-.014a.038.038,0,0,1-.021,0h0l.024,0,0,0-.014,0c.012,0,.013,0,.014,0,.136-.062.044-.032-.035-.008h-.005a.52.52,0,0,0-.157-.05l-.015-.008c-.044-.031-.265-.2-.06-.023-.045-.039-.089-.078-.131-.121a.6.6,0,0,1-.067-.082q-.04-.069-.078-.14l0-.025c0-.021-.006-.03-.009-.043s0-.027.005-.041a.492.492,0,0,0,.029-.128l.009-.011c.033-.046.062-.1.093-.147-.166.252.065-.028.082-.063,0-.006,0,0,0-.007s0,0,.013-.006c.051-.03.1-.064.152-.093s.307-.1.053-.031c.058-.016.113-.037.171-.052.011,0,.1-.015.142-.023l.084,0,.057,0c-.042.006.145.046.2.055l.023.018c.047.034.1.065.153.1-.221-.143,0,.011.045.054.025.025.049.052.072.079a.62.62,0,0,1,.059.081c.036.066.075.134.113.2l.011.017a.051.051,0,0,0,0,.006,1.806,1.806,0,0,0,.088.311.247.247,0,0,1,0,.026c0,.058.008.116.009.174v.012a1.253,1.253,0,0,0-1.143-.008Z",
    transform: "translate(-186.196 -169.191)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M275.17,121.9l0,0,.006,0Z",
    transform: "translate(-65.308 -28.933)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M407.113,319.255h0Z",
    transform: "translate(-197.245 -226.285)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M407.113,319.257h0Z",
    transform: "translate(-197.244 -226.285)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M407.115,319.255s0,0,0,0Z",
    transform: "translate(-197.245 -226.285)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M275.177,121.9Z",
    transform: "translate(-65.31 -28.933)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M466.113,339.255h0Z",
    transform: "translate(-211.248 -231.032)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M468.652,335.779a4.547,4.547,0,0,0-5.509-2.039,4,4,0,0,0-2.28,2.123c-.044.1-.069.213-.105.319-.05.08-.109.153-.154.236a4.544,4.544,0,0,0,7.086,5.429,4.893,4.893,0,0,0,.961-6.068Zm-2.866,1.943C465.8,337.779,465.793,337.832,465.787,337.722Zm-.291-.662Zm-1.284.516C464.195,337.549,464.193,337.545,464.212,337.576Zm.3.258C464.589,337.858,464.56,337.853,464.516,337.833Zm.136.065.03-.014a.038.038,0,0,1-.021,0h0l.024,0,0,0-.014,0c.012,0,.013,0,.014,0,.136-.062.044-.032-.035-.008h-.005a.52.52,0,0,0-.157-.05l-.015-.008c-.044-.031-.265-.2-.06-.023-.045-.039-.089-.078-.131-.121a.594.594,0,0,1-.067-.082q-.04-.069-.078-.14l0-.025c0-.021-.006-.03-.009-.043s0-.027.005-.041a.494.494,0,0,0,.029-.128l.009-.011c.033-.046.062-.1.093-.147-.166.252.065-.028.082-.063,0-.006,0,0,0-.007l.013-.006c.051-.03.1-.064.152-.093s.307-.1.053-.031c.058-.016.113-.037.171-.052.01,0,.1-.015.142-.023l.084,0,.057,0c-.042.006.145.046.2.055l.023.018c.047.034.1.065.153.1-.221-.143,0,.011.045.054.025.025.049.052.072.079a.612.612,0,0,1,.059.081c.036.066.075.134.113.2l.011.017a.057.057,0,0,0,0,.006,1.809,1.809,0,0,0,.088.311c0,.009,0,.017,0,.026,0,.058.008.116.009.174v.012a1.253,1.253,0,0,0-1.143-.008Z",
    transform: "translate(-200.199 -158.273)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M334.17,141.905l0,0,.006,0Z",
    transform: "translate(-79.311 -33.68)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M334.177,141.9Z",
    transform: "translate(-79.313 -33.679)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M466.115,339.255s0,0,0,0Z",
    transform: "translate(-211.248 -231.032)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M466.113,339.257h0Z",
    transform: "translate(-211.247 -231.032)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M438.646,383.38l-35.461,1.971a.782.782,0,0,1-.169-1.552l36.245-5.9Z",
    transform: "translate(682.959 226.145) rotate(135)",
    fill: "#0083d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M937.085,571.88c0-2.275-.764-4.122-1.7-4.126H679.631c-.942,0-1.7,1.851-1.706,4.126v93.661a.85.85,0,0,1-.768.846q-1.03.1-2.059.184c-.017,0-.034,0-.051,0-.374.034-.747.059-1.121.089h0q-.288-.533-.57-1.075a.852.852,0,0,1-.1-.394V566.527c0-.628.026-1.261.068-1.885a24.127,24.127,0,0,1,.318-2.555c.717-3.944,2.339-6.614,4.181-6.622H937.188a1.989,1.989,0,0,1,.781.166,3.046,3.046,0,0,1,.964.675,5.972,5.972,0,0,1,.946,1.295,17.042,17.042,0,0,1,1.787,6.762c0,.025,0,.051,0,.076.059.688.089,1.388.085,2.089l.059,9.1.038,5.425.115,17.022.042,6.045.187,62.061h0a.849.849,0,0,1-.849.849h-3.413a.849.849,0,0,1-.849-.849Z",
    transform: "translate(-260.411 -282.347)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M919.035,499.652H891.477a1.47,1.47,0,0,0-1.468,1.472v43.533h30.5V501.124a1.471,1.471,0,0,0-1.472-1.472Zm-13.687,24.735a3.269,3.269,0,0,1-3.254-3.254v-5.021a3.254,3.254,0,0,1,6.508,0v5.021A3.269,3.269,0,0,1,905.349,524.387Z",
    transform: "translate(-311.856 -269.101)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M889.884,556.837v4.2a.823.823,0,0,0,.821.821H919.75a.825.825,0,0,0,.821-.821v-4.2Z",
    transform: "translate(-311.827 -282.673)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M950.054,410.571h-117.8a3.824,3.824,0,0,0-3.818,3.818V493.88a3.822,3.822,0,0,0,3.818,3.818h117.8a3.822,3.822,0,0,0,3.818-3.818V414.389a3.824,3.824,0,0,0-3.818-3.818Z",
    transform: "translate(-297.243 -247.958)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M949.931,414.186H834.1a2.046,2.046,0,0,0-2.042,2.046v77.521A2.045,2.045,0,0,0,834.1,495.8H949.931a2.045,2.045,0,0,0,2.042-2.042V416.232A2.046,2.046,0,0,0,949.931,414.186Z",
    transform: "translate(-298.102 -248.816)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M935.189,562.968H866.275a1.268,1.268,0,0,1-1.241-1.529l1.069-5.079a1.273,1.273,0,0,1,1.24-1.007H934.12a1.273,1.273,0,0,1,1.24,1.007l1.069,5.079a1.268,1.268,0,0,1-1.241,1.529Z",
    transform: "translate(-305.922 -282.321)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162",
    "data-name": "Rectangle 162",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(561.912 273.947)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_163",
    "data-name": "Rectangle 163",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(566.156 273.947)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_164",
    "data-name": "Rectangle 164",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(570.401 273.947)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    "data-name": "Rectangle 165",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(574.646 273.947)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_166",
    "data-name": "Rectangle 166",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(578.891 273.947)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_167",
    "data-name": "Rectangle 167",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(583.136 273.947)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_168",
    "data-name": "Rectangle 168",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(587.381 273.947)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_169",
    "data-name": "Rectangle 169",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(591.626 273.947)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_170",
    "data-name": "Rectangle 170",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(595.871 273.947)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_171",
    "data-name": "Rectangle 171",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(600.116 273.947)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_172",
    "data-name": "Rectangle 172",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(604.361 273.947)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_173",
    "data-name": "Rectangle 173",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(608.606 273.947)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_174",
    "data-name": "Rectangle 174",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(612.851 273.947)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_175",
    "data-name": "Rectangle 175",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(617.096 273.947)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176",
    "data-name": "Rectangle 176",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(621.341 273.947)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177",
    "data-name": "Rectangle 177",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(625.586 273.947)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178",
    "data-name": "Rectangle 178",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(561.861 276.07)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_179",
    "data-name": "Rectangle 179",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(566.106 276.07)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_180",
    "data-name": "Rectangle 180",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(570.351 276.07)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_181",
    "data-name": "Rectangle 181",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(574.596 276.07)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(578.841 276.07)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183",
    "data-name": "Rectangle 183",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(583.086 276.07)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_184",
    "data-name": "Rectangle 184",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(587.331 276.07)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_185",
    "data-name": "Rectangle 185",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(591.576 276.07)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_186",
    "data-name": "Rectangle 186",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(595.821 276.07)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_187",
    "data-name": "Rectangle 187",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(600.066 276.07)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188",
    "data-name": "Rectangle 188",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(604.311 276.07)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_189",
    "data-name": "Rectangle 189",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(608.556 276.07)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_190",
    "data-name": "Rectangle 190",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(612.801 276.07)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_191",
    "data-name": "Rectangle 191",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(617.046 276.07)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_192",
    "data-name": "Rectangle 192",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(621.291 276.07)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_193",
    "data-name": "Rectangle 193",
    width: 2.122,
    height: 1.273,
    rx: 0.488,
    transform: "translate(625.536 276.07)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_194",
    "data-name": "Rectangle 194",
    width: 16.98,
    height: 1.273,
    rx: 0.488,
    transform: "translate(582.237 278.617)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M945.115,427.923H836.732a.431.431,0,1,1,0-.862H945.115a.431.431,0,1,1,0,.862Z",
    transform: "translate(-299.109 -251.872)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 2.526,
    cy: 2.582,
    rx: 2.526,
    ry: 2.582,
    transform: "translate(542.474 167.824)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_46",
    "data-name": "Ellipse 46",
    cx: 2.526,
    cy: 2.582,
    rx: 2.526,
    ry: 2.582,
    transform: "translate(551.201 167.824)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_47",
    "data-name": "Ellipse 47",
    cx: 2.526,
    cy: 2.582,
    rx: 2.526,
    ry: 2.582,
    transform: "translate(559.926 167.824)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M970.014,418.243h-6.2a.469.469,0,1,0,0,.939h6.2a.469.469,0,1,0,0-.939Z",
    transform: "translate(-329.262 -249.779)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M970.014,420.553h-6.2a.469.469,0,1,0,0,.939h6.2a.469.469,0,1,0,0-.939Z",
    transform: "translate(-329.262 -250.327)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M970.014,422.86h-6.2a.469.469,0,1,0,0,.939h6.2a.469.469,0,1,0,0-.939Z",
    transform: "translate(-329.262 -250.875)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_195",
    "data-name": "Rectangle 195",
    width: 17.227,
    height: 3.684,
    rx: 1.842,
    transform: "translate(585.18 199.533)",
    fill: "#0083d2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196",
    "data-name": "Rectangle 196",
    width: 34.725,
    height: 3.684,
    rx: 1.842,
    transform: "translate(576.431 206.901)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_197",
    "data-name": "Rectangle 197",
    width: 34.725,
    height: 3.684,
    rx: 1.842,
    transform: "translate(576.431 214.268)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M581.774,417.469l.432,1.091h-.432Z",
    transform: "translate(-138.078 -99.083)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371",
    transform: "translate(31.104 60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M351.26,459.943H338.184a2.987,2.987,0,0,1-2.956-2.568,66.488,66.488,0,0,1,0-17.907,2.988,2.988,0,0,1,2.905-2.567,16.36,16.36,0,0,1,13.172,0,2.953,2.953,0,0,1,2.247,1.084,3.021,3.021,0,0,1,.623,2.518,40.2,40.2,0,0,0,0,15.839,3.021,3.021,0,0,1-.623,2.518,2.952,2.952,0,0,1-2.292,1.084Z",
    transform: "translate(-180.039 -253.879)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M351,445.854H340a.688.688,0,1,1,0-1.376H351a.688.688,0,1,1,0,1.376Z",
    transform: "translate(-181.152 -256.005)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M351,453.07H340a.688.688,0,1,1,0-1.376H351a.688.688,0,1,1,0,1.376Z",
    transform: "translate(-181.152 -257.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M351,460.286H340a.688.688,0,1,1,0-1.376H351a.688.688,0,1,1,0,1.376Z",
    transform: "translate(-181.152 -259.431)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M1023.9,472.661l-2.227,11.173c-.168.854-.343,1.724-.534,2.585a10.9,10.9,0,0,0-5.6.313,52.269,52.269,0,0,1,3.844,6.429c-1.4,4.324-3.463,8.321-6.91,11.211a17.327,17.327,0,0,1-16.74,2.944l.1-.442c-3.706-7.192-1.693-16.26,2.913-22.9a44.529,44.529,0,0,1,8.275-8.748c3.112-2.593,6.475-4.919,9.808-7.215a4.568,4.568,0,0,1,7.07,4.652Z",
    transform: "translate(-336.516 -261.399)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a4b268fa-75d0-4ac1-9d87-14bdca948464-2189-2",
    "data-name": "a4b268fa-75d0-4ac1-9d87-14bdca948464-2189",
    d: "M996.885,541.245c-.937-6.828-1.9-13.743-1.244-20.644a32.468,32.468,0,0,1,6.261-17.023,28.32,28.32,0,0,1,7.266-6.584c.727-.458,1.395.693.672,1.149a26.922,26.922,0,0,0-10.649,12.848c-2.318,5.9-2.691,12.325-2.288,18.589.242,3.788.754,7.55,1.27,11.31a.686.686,0,0,1-.465.819.67.67,0,0,1-.819-.465Z",
    transform: "translate(-336.876 -268.445)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M844.979,701.776l-712.132.234a.908.908,0,0,1,0-1.816l712.132-.234a.908.908,0,1,1,0,1.816Z",
    transform: "translate(-131.934 -316.642)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365",
    transform: "translate(22620.016 6452.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M-21562.746-6204.7s-19.83,14.833-29.666,10.8-16.121-18.847-9.51-20.476,9.51,1.128,9.51,1.128,13.383-12.414,23.539-10.318S-21562.746-6204.7-21562.746-6204.7Z",
    transform: "translate(-644.352 18.275)",
    fill: "#1c2124",
    stroke: "#1c2124",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M-21532.822-6310.653s-22.732-9.673-27.086-14.188-14.834.645-12.736,11.609,30.311,14.671,40.467,12.9S-21532.822-6310.653-21532.822-6310.653Z",
    transform: "translate(-661.701 74.41)",
    fill: "#fff",
    stroke: "#1c2124",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M-21481.883-6296.853s12.365,50.092-5.238,58.057-23.266,5.051-26.828,2.306-27.666-16.977-21.168-32.7,19.051-7.335,19.051-7.335-5.01-5.659,8.613-22.426S-21481.883-6296.853-21481.883-6296.853Z",
    transform: "translate(-683.576 65.058)",
    fill: "#1c2124",
    stroke: "#1c2124",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M-21479.473-6253.937c-5.455,5.679-7.762,10.92-18.24,12.177s-3.982,17.815,5.66,16.558,19.072-7.545,17.813-16.558S-21474.018-6259.617-21479.473-6253.937Z",
    transform: "translate(-699.884 35.732)",
    fill: "#fff",
    stroke: "#1c2124",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M-21526.572-6185.395c-2.885-.661-10.641-4.676-16.93,16.284s-4.98,22.25-4.98,22.25-6.934,0-6.125,5,17.895,12.736,24.021,1.451,13.381-21.765,14.348-27.569S-21523.687-6184.734-21526.572-6185.395Z",
    transform: "translate(-671.675 -2.32)",
    fill: "#fff",
    stroke: "#1c2124",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M-21517.588-6342.171a4.163,4.163,0,0,0-1.525,5.532c1.637,3.782,2.994,4.968,2.994,4.968Z",
    transform: "translate(-690.859 82.992)",
    fill: "#fff",
    stroke: "#1c2124",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_83",
    "data-name": "Ellipse 83",
    transform: "translate(-22208.818 -6283.578)",
    fill: "#fff",
    stroke: "#1c2124",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.462,
    cy: 29.462,
    r: 29.462,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.462,
    cy: 29.462,
    r: 28.962,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M-21512.3-6355.006c.551-1.764-.506-2.173-1.807-2.483s-2.836-.522-3.385,1.242.336,5.763,1.184,5.813S-21512.852-6353.242-21512.3-6355.006Z",
    transform: "translate(-691.908 91.482)",
    fill: "#1c2124",
    stroke: "#1c2124",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_84",
    "data-name": "Ellipse 84",
    transform: "translate(-22193.955 -6266.992) rotate(-31)",
    fill: "#1c2124",
    stroke: "#1c2124",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.399,
    cy: 2.946,
    rx: 3.399,
    ry: 2.946,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.399,
    cy: 2.946,
    rx: 2.899,
    ry: 2.446,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M0,10.211C.127,5.014,6.328,1.665,8.312.549s8.559-.992,4.714,4.837-2.854,10.045-1.862,11.782.87,8.185-3.72,4.341S-.121,15.407,0,10.211Z",
    transform: "matrix(0.883, -0.469, 0.469, 0.883, -22199.439, -6266.435)",
    fill: "none",
    stroke: "#1c2124",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M-21515.625-6341.308s-3.6,4.24,1.736,9.821,14.262,2.233,14.385,1.24",
    transform: "translate(-692.377 82.52)",
    fill: "#fff",
    stroke: "#1c2124",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M865.83,445.3a23.666,23.666,0,0,1-13.009,9.159,27.207,27.207,0,0,1-6.476,1.1,24.488,24.488,0,0,0-1.925-7.195,20.207,20.207,0,0,1-1,7.178,24.056,24.056,0,0,1-9.468-2.537,20.862,20.862,0,0,1-11.163-14.973c-1.156-7.464,2.228-14.794,3.452-22.246s-1.077-16.892-8.373-18.851c-5.556-1.493-4.933-.847-9.552,2.582,4.8,7.1-12.942,33.137-20.2,30.867-4.106-1.283-6.734-5.051-7.582-5.051-5.707,9.832,5.04,26.4-5.792,29.84l.892-.892c6.538-8.042-6.538-27.521,0-35.563,1.824-2.25,9.974-4.844,9.435-7.689-.511-2.705-2.428-14.092-2.428-14.092s-11.507,2.469-17.035,1.139c-4.911-1.184-4.821.275-9.748.909a24.454,24.454,0,0,0-1.79-6.179,20.051,20.051,0,0,1-.735,6.3,7.906,7.906,0,0,1-4.781-1.729c-4.018-3.238-3.2-10.04.381-13.75s8.929-5.045,14.019-5.91c1.479-10.3,29.91-11.379,33.678-1.083,1.605-7.689,11.23-11.679,18.711-9.294s12.672,9.372,15.405,16.735,3.5,15.276,5.18,22.942,4.529,15.473,10.388,20.7,15.405,6.948,21.579,2.1a17.282,17.282,0,0,1-2.06,15.489Z",
    transform: "translate(-22946.402 -6673.048)",
    fill: "#1c2124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M-21427.459-6375.679c-3.469,6.7-1.982,16.369,4.713,13.89s15.625-12.65,11.162-17.238S-21423.984-6382.376-21427.459-6375.679Z",
    transform: "translate(-740.239 104.637)",
    fill: "#2b3033",
    stroke: "#1c2124",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M-21429.5-6361.418c.076-1.364,2.059-5.829,4.912-7.193s7.316.5,5.332,4.093-8.186,9.8-9.549,7.565S-21429.58-6360.054-21429.5-6361.418Z",
    transform: "translate(-740.006 97.693)",
    fill: "#fff",
    stroke: "#1c2124",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366",
    transform: "translate(-44.408 -32.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M735.26,577.943H722.184a2.987,2.987,0,0,1-2.956-2.568,66.486,66.486,0,0,1,0-17.907,2.987,2.987,0,0,1,2.905-2.567,16.36,16.36,0,0,1,13.172,0,2.953,2.953,0,0,1,2.247,1.084,3.021,3.021,0,0,1,.623,2.518,40.2,40.2,0,0,0,0,15.839,3.021,3.021,0,0,1-.623,2.518,2.952,2.952,0,0,1-2.292,1.084Z",
    transform: "translate(-271.18 -281.885)",
    fill: "#0083d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M735,563.854H724a.688.688,0,1,1,0-1.376H735a.688.688,0,1,1,0,1.376Z",
    transform: "translate(-272.291 -284.012)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M735,571.07H724a.688.688,0,1,1,0-1.376H735a.688.688,0,1,1,0,1.376Z",
    transform: "translate(-272.291 -285.725)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M735,578.286H724a.688.688,0,1,1,0-1.376H735a.688.688,0,1,1,0,1.376Z",
    transform: "translate(-272.291 -287.437)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367",
    transform: "translate(-10 34.394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M652.26,415.943H639.184a2.987,2.987,0,0,1-2.956-2.568,66.493,66.493,0,0,1,0-17.907,2.988,2.988,0,0,1,2.905-2.567,16.361,16.361,0,0,1,13.172,0,2.953,2.953,0,0,1,2.247,1.084,3.021,3.021,0,0,1,.623,2.518,40.2,40.2,0,0,0,0,15.839,3.021,3.021,0,0,1-.623,2.518A2.953,2.953,0,0,1,652.26,415.943Z",
    transform: "translate(-251.48 -243.436)",
    fill: "#0083d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M652,401.854H641a.688.688,0,0,1,0-1.376H652a.688.688,0,1,1,0,1.376Z",
    transform: "translate(-252.592 -245.563)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M652,409.07H641a.688.688,0,0,1,0-1.376H652a.688.688,0,1,1,0,1.376Z",
    transform: "translate(-252.592 -247.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M652,416.286H641a.688.688,0,0,1,0-1.376H652a.688.688,0,1,1,0,1.376Z",
    transform: "translate(-252.592 -248.988)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368",
    transform: "translate(22008.645 6521.555)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M-21694.812-6061.065s-8.977,38.714,2.721,41.22,15.318-.835,16.988-10.583,8.076-28.965,3.9-38.992c-1.422-10.027-.336-24.231-8.383-18.939S-21694.812-6061.065-21694.812-6061.065Z",
    transform: "translate(-61.773 -121.367)",
    fill: "#1c2124",
    stroke: "#1c2124",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M-21672.879-6138.854s14.2-2.228,26.457,13.647,11.977,27.852,5.293,24.231-19.5-7.242-26.738-18.1S-21672.879-6138.854-21672.879-6138.854Z",
    transform: "translate(-75.137 -94.825)",
    fill: "#fff",
    stroke: "#1c2124",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M-21777.508-6171.124s-19.25-33.162-29.275-32.02-6.963,24.258,0,33.449,20.611,22.309,24.232,17.546S-21777.508-6171.124-21777.508-6171.124Z",
    transform: "translate(0 -60.364)",
    fill: "#fff",
    stroke: "#1c2124",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M-21745.912-6156.034s-20.609,24.509-13.646,61.551c-3.064,12.227-6.129,32.029,0,42.056s17.545,4.178,19.5,0,3.342-38.435,6.963-42.056,18.326-3.342,25.594-16.153c3.371-6.406-6.656-37.878-12.506-43.727S-21745.912-6156.034-21745.912-6156.034Z",
    transform: "translate(-26.891 -84.887)",
    fill: "#fff",
    stroke: "#1c2124",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    transform: "translate(-21766.314 -6198.592)",
    fill: "#1c2124",
    stroke: "#1c2124",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.73,
    cy: 9.73,
    r: 9.73,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.73,
    cy: 9.73,
    r: 9.23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_85",
    "data-name": "Ellipse 85",
    transform: "translate(-21794.578 -6304.691)",
    fill: "#fff",
    stroke: "#1c2124",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36.602,
    cy: 36.602,
    r: 36.602,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.602,
    cy: 36.602,
    r: 36.102,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M-21650.66-6278.931s6.684,9.191,15.318,2.785,6.963-26.181-1.951-23.4-17.043,7.492-15.623,14.455S-21650.66-6278.931-21650.66-6278.931Z",
    transform: "translate(-85.938 -8.501)",
    fill: "#2b3033",
    stroke: "#1c2124",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M-21744.047-6293.281s6.125-3.621,6.125-8.355-12.531-18.939-17.824-12.255-6.406,17.268,0,22S-21744.047-6293.281-21744.047-6293.281Z",
    transform: "translate(-28.478)",
    fill: "#fff",
    stroke: "#1c2124",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M483.547,417.134l8.461,11.4c2.36-.12,27.647,1.624,29.363,0,.923-1,2.282-7.744,2.736-9.029,1.7-3.955,1.624-11.9,3.283-15.87,2.295-5.5-1.33-14.833-1.916-20.76-.137-2.706-4.926-7.22-6.84-9.139-2.008-1.9-7.14-1.46-9.489,0a12.505,12.505,0,0,0-6.207-9.012,19.166,19.166,0,0,0-10.93-2.317,26.382,26.382,0,0,0-15.023,5.921,32.618,32.618,0,0,1-3.833,3.037,6.017,6.017,0,0,1-4.678.865,3.385,3.385,0,0,1-2.485-3.69,6.513,6.513,0,0,0-1.666,8.6,6.01,6.01,0,0,1-5.874-.695,7.181,7.181,0,0,0,0,12.864c2.442,1.214,3.7,2.841,5.877,1.193,1.118,1.565,2.358,1.791,2.213,3.709s.369,4.3,2.218,4.832c2.5.717,4.524-2.649,7.124-2.613a3.91,3.91,0,0,1,3.1,2,11.541,11.541,0,0,1,1.241,3.624l3.328,14.981",
    transform: "translate(-22246.125 -6680.67)",
    fill: "#1c2124"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369",
    transform: "translate(0.627 202.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_229-2",
    "data-name": "Path 229",
    d: "M-21670.156-6059.427s10.035,40.945-3.041,43.6-17.123-.884-18.99-11.193-9.027-30.635-4.359-41.239c1.59-10.6.375-25.628,9.371-20.03S-21670.156-6059.427-21670.156-6059.427Z",
    transform: "translate(19794.746 10921.277) rotate(13)",
    fill: "#1c2124",
    stroke: "#1c2124",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230-2",
    "data-name": "Path 230",
    d: "M-21636.871-6138.854s-14.2-2.228-26.457,13.647-11.977,27.852-5.293,24.231,19.5-7.242,26.738-18.1S-21636.871-6138.854-21636.871-6138.854Z",
    transform: "translate(21673.203 6223.513)",
    fill: "#1c2124",
    stroke: "#1c2124",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231-2",
    "data-name": "Path 231",
    d: "M-21813.2-6171.124s19.25-33.162,29.275-32.02,6.963,24.258,0,33.449-20.611,22.309-24.232,17.546S-21813.2-6171.124-21813.2-6171.124Z",
    transform: "translate(18451.895 13339.896) rotate(20)",
    fill: "#1c2124",
    stroke: "#1c2124",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228-2",
    "data-name": "Path 228",
    d: "M-21724.018-6156.034s20.609,24.509,13.646,61.551c3.064,12.227,6.129,32.029,0,42.056s-17.545,4.178-19.5,0-3.342-38.435-6.963-42.056-18.326-3.342-25.594-16.153c-3.371-6.406,6.656-37.878,12.506-43.727S-21724.018-6156.034-21724.018-6156.034Z",
    transform: "translate(21785.137 6233.451)",
    fill: "#1c2124",
    stroke: "#1c2124",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_86-2",
    "data-name": "Ellipse 86",
    transform: "translate(30.712 123.187)",
    fill: "#fff",
    stroke: "#1c2124",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.73,
    cy: 9.73,
    r: 9.73,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.73,
    cy: 9.73,
    r: 9.23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_85-2",
    "data-name": "Ellipse 85",
    transform: "translate(9.691 13.646)",
    fill: "#fff",
    stroke: "#1c2124",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36.602,
    cy: 36.602,
    r: 36.602,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.602,
    cy: 36.602,
    r: 36.102,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_226-2",
    "data-name": "Path 226",
    d: "M-21632.082-6278.931s-6.684,9.191-15.318,2.785-6.963-26.181,1.951-23.4,17.043,7.492,15.623,14.455S-21632.082-6278.931-21632.082-6278.931Z",
    transform: "translate(21656.996 6309.837)",
    fill: "#2b3033",
    stroke: "#2b3033",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M22.037,120.963s.832-15.6,3.842-19.427,37.484-7.387,46.787-1.915,2.463,39.127,2.463,39.127S65.553,117.132,45.3,117.406,22.037,120.963,22.037,120.963Z",
    fill: "#fff",
    stroke: "#1c2124",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370",
    transform: "translate(-85.003 -158.865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M222.431,380.515c-1.831.879-3.881-.443-5.461-1.753l.565.488c-2.794,2.718-4.1,6.629-4.738,10.479s-.71,7.779-1.515,11.6-2.475,7.647-5.594,9.983c-4.179,3.129-9.942,2.928-15.071,1.969l-.2-.038a31.308,31.308,0,0,0,1.649-12.412,28.467,28.467,0,0,1-6.834,11.2,65.359,65.359,0,0,1-9.924-3.616c-2.074-.954-4.307-2.26-4.882-4.47-.577-2.193.763-4.494,2.555-5.878s3.991-2.107,6.032-3.094,4.054-2.382,4.87-4.5c1.882-4.862-3.479-10.441-1.39-15.221,1.03-2.35,3.554-3.629,5.926-4.614a86.969,86.969,0,0,1,11.129-3.754c3.327-.878,6.8-1.56,10.19-.984s6.71,2.637,7.93,5.856c2.035.688,4.2,1.463,5.5,3.176S224.369,379.587,222.431,380.515Z",
    transform: "translate(-120.485 -175.295)",
    fill: "#1c2124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M279.811,380.425c-12.308-9.716-22.259-8.058-29.935-2.021-1.291-1.436-6.783,2.514-8.642,1.947l-6.726,12.626c-3.461,6.107-4.881,12.342-4.321,15.85-6.366,17.853,8.731,29.909,26.584,36.275a34.066,34.066,0,0,0,22.092.32l.219-3.042,1.352,2.493s1.055-.96,4.912.549c-2.34-6.071,6.754-.356,5.031-6.371-2.362-8.183-.749-21.183.64-29.154a45.171,45.171,0,0,0,.134-14.866l-.034-.215,3.819,7.709,8.568-5.388C300.228,387.6,300.162,376.191,279.811,380.425Z",
    transform: "translate(-137.93 -210.421)",
    fill: "#1c2124",
    stroke: "#f5f7f8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M52.14,33.388c-1.831-.879-3.881.443-5.461,1.753l.565-.488c-2.794-2.718-4.1-6.629-4.738-10.479s-.71-7.779-1.515-11.6S38.516,4.93,35.4,2.594C31.218-.536,25.455-.335,20.327.624l-.2.038a31.308,31.308,0,0,1,1.649,12.412,28.468,28.468,0,0,0-6.834-11.2A65.361,65.361,0,0,0,5.018,5.489C2.944,6.444.711,7.749.136,9.959-.441,12.152.9,14.452,2.69,15.837s3.99,2.107,6.032,3.094,4.054,2.382,4.87,4.5c1.882,4.862-3.479,10.441-1.39,15.221,1.03,2.35,3.554,3.629,5.926,4.614a86.973,86.973,0,0,0,11.129,3.754c3.327.878,6.8,1.56,10.19.984s6.71-2.637,7.93-5.856c2.035-.688,4.2-1.463,5.5-3.176S54.079,34.316,52.14,33.388Z",
    transform: "matrix(-0.998, -0.07, 0.07, -0.998, 188.698, 238.608)",
    fill: "#1c2124",
    stroke: "#f5f7f8",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_227-2",
    "data-name": "Path 227",
    d: "M-21754.016-6293.281s-6.125-3.621-6.125-8.355,12.531-18.939,17.824-12.255,6.406,17.268,0,22S-21754.016-6293.281-21754.016-6293.281Z",
    transform: "translate(21810.313 6316.517)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandas);
export default __webpack_public_path__ + "static/media/pandas.d86c61aee09364deebccc06826de47b8.svg";
export { ForwardRef as ReactComponent };